export default "__VITE_PUBLIC_ASSET__543f0f62__"